import { createApp } from "vue";
import router from "./router";
import App from "./App.vue";
import "./assets/scss/style.scss";
import "bootstrap"

createApp(App).use(router).mount("#app");